'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _create = require('babel-runtime/core-js/object/create');

var _create2 = _interopRequireDefault(_create);

var _commonMenuItem = require('./commonMenuItem');

var _commonMenuItem2 = _interopRequireDefault(_commonMenuItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Secondary Menu Item
 * @constructor
 */
function SecondaryMenuItem() {
  _commonMenuItem2.default.prototype.constructor.apply(this, arguments);
} /**
   * @module navigation/secondaryMenuItem
   * @requires module: navigation/commonMenuItem
   * @author: Serhii Atiahin [serhii.atiahin@racingpost.com]
   */

SecondaryMenuItem.prototype = (0, _create2.default)(_commonMenuItem2.default.prototype);

exports.default = SecondaryMenuItem;


//////////////////
// WEBPACK FOOTER
// ./~/rp-navigation/lib/navigation/secondaryMenuItem.js
// module id = 1516
// module chunks = 0